import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getIncidents: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INCIDENTS].GET_INCIDENTS,
	},
	getIncidentPreview: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INCIDENTS].GET_INCIDENT_PREVIEW,
	},
	getIncidentPopup: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INCIDENTS].GET_INCIDENT_POPUP,
	},
	createIncident: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INCIDENTS].CREATE_INCIDENT,
	},
	getIncident: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INCIDENTS].GET_INCIDENT,
	},
	patchIncident: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INCIDENTS].PATCH_INCIDENT,
	},
	patchIncidentClose: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INCIDENTS].PATCH_INCIDENT_CLOSE,
	},
	putIncident: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INCIDENTS].PUT_INCIDENT,
	},
	deleteIncident: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INCIDENTS].DELETE_INCIDENT,
	},
}
